<div class="modal-header">
  <div class="font-xl fw-bold text-center">
    <span [translate]="'modal.importReminders.header'"></span>
    <i class="icon-close" (click)="close()"></i>
  </div>
</div>
<div class="modal-body">
  <ui-message class="d-block mt-2 mb-4" [type]="'success'" *ngIf="remindersCount">
    {{ 'modal.importReminders.remindersImportSuccess' | translate: {remindersCount: remindersCount} }}
  </ui-message>

  <div *ngIf="remindersErrors || isFileError()">
    <ui-message class="d-block mb-4" [type]="'error'" [title]="'Oops'">
      <span [translate]="'modal.importReminders.fileError'">
        Error in excel file.
      </span>&nbsp;
      <span *ngIf="!isFileError()"
            [translate]="'modal.importReminders.checkErrorsBelowAndTryAgain'">
        Please check errors below and try to upload again.
      </span>
    </ui-message>

    <div *ngIf="!isFileError()">
      <div class="row pb-1">
        <div class="col-2 fw-bold"
             [translate]="'modal.importReminders.rowNumber'">Row
        </div>
        <div class="col-6 fw-bold"
             [translate]="'common.name'">Name
        </div>
        <div class="col-4 fw-bold"
             [translate]="'common.date'">Date
        </div>
      </div>
      <div class="error-row"
           *ngFor="let error of remindersErrors">
        <div class="row">
          <div class="col-2">{{error.row}}</div>
          <div class="col-6"
               [class.text-danger]="error.name.invalid">
            {{error.name.value || ('modal.importReminders.emptyNameError' | translate)}}
          </div>
          <div class="col-4"
               [class.text-danger]="error.date.invalid">
            {{error.date.value || ('modal.importReminders.emptyDateError' | translate)}}
          </div>
        </div>
      </div>
    </div>

    <div class="text-center mt-4 mb-4">
      <button class="btn btn-pink"
              [translate]="'modal.importReminders.tryAgain'"
              (click)="init()">Try again
      </button>
    </div>
  </div>

  <div *ngIf="!remindersCount && !remindersErrors && !isFileError()">
    <div [innerHTML]="'modal.importReminders.hereYouCanImportRemindersOrDownloadTemplate' | translate"></div>

    <div class="mt-4" [innerHTML]="'modal.importReminders.descriptionExelStructure' | translate"></div>

    <div class="mt-3"
         [translate]="'modal.importReminders.topRowIsNotRegistered'">
      OBS! Top row is not registered.
    </div>

    <div class="d-flex justify-content-center align-items-end mt-4 mb-3">
      <div>
        <div class="fw-bold font-sm mb-1"
             [translate]="'modal.importReminders.selectOccasion'">Select the occasion
        </div>
        <ui-select
          [placeholder]="'modal.importReminders.selectOccasion' | translate"
          [extraClasses]="'w-100'"
          [items]="reminderReasons"
          [(model)]="reason">
        </ui-select>
      </div>

      <div>
        <input type="file" #file style="display: none"
               accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
               (change)="onFilesAdded()"/>
        <button class="btn btn-pink ms-4"
                [translate]="'modal.importReminders.uploadFile'"
                (click)="addFiles()">Upload file
        </button>
      </div>
    </div>
  </div>

</div>
